import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {$TurboModePopup} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UITurboModePopup/components/TurboModePopup';
import {Store} from '@gongxigames/framework/core';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';
import {Container} from 'pixi.js';

export class UITurboModePopupModule extends UIModuleV2 {
    static NAME = 'UITurboModePopupModule';

    public static layer = LAYERS.KEYPAD;
    public container = new Container();

    protected showPopup = Store.signal(false);
    protected turboCheckbox = Store.signal(false);

    onInit(): void {
        const uiDefault = $TurboModePopup({
            showPopup: this.showPopup,
            turboCheckbox: this.turboCheckbox
        }) as Container;

        this.container.addChild(uiDefault);
    }

    protected onSetupEvents(): void {
        this.emitter.once('UI.showTurboModeHint', this.onShow.bind(this));
    }

    protected onShow(): void {
        this.showPopup.value = true;
        this.turboCheckbox.value = slotStore.reelsSpeedLevel.value !== ReelsSpeedLevel.normal;

        Store.effect(()=>{
            const nextSpeedLevel = this.turboCheckbox.value ? ReelsSpeedLevel.turbo_2 : ReelsSpeedLevel.normal;

            this.emitter.emit('UI.reelSpin.setLevel', nextSpeedLevel);
        }, {signal: this.abortSignal});
    }
}